import React from 'react'
import { Card, Space, Typography, Spin, Empty } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { authService } from '../../../shared/api/services/auth.service'
import { formatIST } from '../../../shared/utils/formatters'

const { Text } = Typography

interface AuditLogEntry {
    action: string
    ip_address: string
    user_agent: string
    created_at: string
    metadata?: {
        reason?: string
        [key: string]: any
    }
}

export const ActivityLog: React.FC = () => {
    const { data: response, isLoading } = useQuery({
        queryKey: ['admin_activity_log'],
        queryFn: () => authService.getActivityLog(),
    })

    const logs: AuditLogEntry[] = response?.data || []

    const formatActionName = (action: string) => {
        // e.g. "auth.login.success" -> "Auth Login Success"
        return action
            .split('.')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }

    const formatUserAgent = (ua: string) => {
        if (!ua) return 'Unknown Device'
        // Very basic parsing for display
        if (ua.includes('Windows')) return 'Windows Device'
        if (ua.includes('Mac OS')) return 'Mac OS Device'
        if (ua.includes('Linux')) return 'Linux Device'
        if (ua.includes('Android')) return 'Android Device'
        if (ua.includes('iPhone')) return 'iPhone'
        return 'Web Browser'
    }

    return (
        <Card title="Recent Activity">
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '24px 0' }}>
                    <Spin />
                </div>
            ) : logs.length === 0 ? (
                <Empty description="No recent activity found" />
            ) : (
                <Space direction="vertical" style={{ width: '100%' }}>
                    {logs.map((log, index) => (
                        <div key={index} style={{ padding: '12px 0', borderBottom: index < logs.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                            <Text strong>{formatActionName(log.action)}</Text>
                            {log.metadata?.reason && (
                                <Text type="danger" style={{ marginLeft: 8 }}>
                                    ({log.metadata.reason})
                                </Text>
                            )}
                            <br />
                            <Text type="secondary">
                                {formatUserAgent(log.user_agent)} • IP: {log.ip_address || 'Unknown'} • {formatIST(log.created_at)}
                            </Text>
                        </div>
                    ))}
                </Space>
            )}
        </Card>
    )
}
